import script from "./ProductsTable.vue?vue&type=script&setup=true&lang=js"
export * from "./ProductsTable.vue?vue&type=script&setup=true&lang=js"

import "./ProductsTable.vue?vue&type=style&index=0&id=14352e96&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-14352e96"]])

export default __exports__